/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import themeConfig from "@/../themeConfig.js";
import colors from "@/../themeConfig.js";

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function(query) {
    return window.matchMedia(query).matches;
  };

  if ("ontouchstart" in window || window.DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser: null,
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  is_touch_device: is_touch_device(),
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.primary,
  languages: null,
  currencies: null,
  contactMethods: null,
  paymentConditions: null,
  cartItems: [],
  baseData: {
    ageGroups: null,
    categories: null,
    countries: null,
    occupations: null,
    periodicalTypes: null,
    securityQuestions: null,
    deliveryTypes: null
  },
  publicationsPaperFilterList: null,
  publicationsDigitalFilterList: null,
  latestFilter: null,
  latestSearch: "",
  invoicesStatusList: [
    {
      title: "invoicesStatusList.new",
      id: 0
    },
    {
      title: "invoicesStatusList.inProgress",
      id: 1
    },
    {
      title: "invoicesStatusList.deleted",
      id: 2
    },
    {
      title: "invoicesStatusList.done",
      id: 3
    },
    {
      title: "invoicesStatusList.ignored",
      id: 4
    },
    {
      title: "invoicesStatusList.canceled",
      id: 5
    },
    {
      title: "invoicesStatusList.active",
      id: 6
    }
  ],
  orderDisplayStatusList: [
    {
      title: "orderDisplayStatusList.pending",
      id: 0
    },
    {
      title: "orderDisplayStatusList.active",
      id: 1
    },
    {
      title: "orderDisplayStatusList.onhold",
      id: 2
    },
    {
      title: "orderDisplayStatusList.done",
      id: 3
    },
    {
      title: "orderDisplayStatusList.canceled",
      id: 4
    },
    {
      title: "orderDisplayStatusList.waiting",
      id: 5
    }
  ],
  publisherInvoicesStatusList: [
    {
      title: "publisherInvoicesStatusList.new",
      id: 0
    },
    {
      title: "publisherInvoicesStatusList.inProgress",
      id: 1
    },
    {
      title: "publisherInvoicesStatusList.delivered",
      id: 2
    },
    {
      title: "publisherInvoicesStatusList.notDelivered",
      id: 3
    },
    {
      title: "publisherInvoicesStatusList.ignored",
      id: 4
    }
  ],
  claimsStatusList: [
    {
      title: "claimsStatusList.pendingToReview",
      id: 0
    },
    {
      title: "claimsStatusList.sentToPublisher",
      id: 1
    },
    {
      title: "claimsStatusList.repliedFromPublisher",
      id: 2
    },
    {
      title: "claimsStatusList.canceled",
      id: 3
    },
    {
      title: "claimsStatusList.repliedFromAdmin",
      id: 4
    }
  ],
  claimsStateList: [
    {
      title: "claimsStateList.notResolved",
      id: 0
    },
    {
      title: "claimsStateList.resolved",
      id: 1
    }
  ],
  claimRoles: [
    {
      title: "senders.customer",
      id: 0
    },
    {
      title: "senders.publisher",
      id: 1
    },
    {
      title: "senders.admin",
      id: 2
    }
  ],
  siteConfig: {
    default_language:
      {
        "id": 12,
        "slug": "Svenska",
        "icon": "https://ferdosiinfo.com/media/icons/sweden.png",
        "title": "Svenska",
        "codename": "se",
        "use_in_site": true
      }

  },
  preferred: null,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null
};

export default state;
